// App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'; 
import Leaderboard from './Leaderboard';
import Question from './Question'; // <-- 1. Import ไฟล์ใหม่
import './App.css';
import 'antd/dist/reset.css';

function App() {
  // (โค้ดส่วนอื่นเหมือนเดิม)

  return (
    <div className="App">
      <Routes>
        
        {/* Route หลัก: แสดง Leaderboard */}
        <Route
          path="/"
          element={
            <Leaderboard userData={null} /> 
          }
        />

        {/* --- 2. เพิ่ม Route สำหรับหน้าคำตอบ --- */}
        <Route
          path="/question"
          element={
            <Question /> 
          }
        />
        {/* --------------------------------- */}


        {/* Route Catch-all: หากเข้าหน้าอื่น ให้เด้งกลับมาหน้าหลัก */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </div>
  );
}

export default App;